import { render } from "./CreateAssembly.vue?vue&type=template&id=76be0e3e"
import script from "./CreateAssembly.vue?vue&type=script&lang=js"
export * from "./CreateAssembly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__